/* @license @webcam/core v0.0.0 */
var e=function(){return"mediaDevices"in navigator&&navigator.mediaDevices.enumerateDevices?navigator.mediaDevices.enumerateDevices():Promise.reject(new Error("Method enumerateDevices of Navigator is not implemented in this browser"))};export{e as getDevices};
//# sourceMappingURL=getDevices.js.map
